import { render, staticRenderFns } from "./DoughnutOrderAmount.vue?vue&type=template&id=791985a2&scoped=true&"
import script from "./DoughnutOrderAmount.vue?vue&type=script&lang=js&"
export * from "./DoughnutOrderAmount.vue?vue&type=script&lang=js&"
import style0 from "./DoughnutOrderAmount.vue?vue&type=style&index=0&id=791985a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791985a2",
  null
  
)

export default component.exports